module.exports = __webpack_public_path__ + "img/LogoNovo-Retextoar-cinza.1bd1858c.png";